import {
  DOCUMENT_CATEGORIES_SORTED,
  DOCUMENT_SUB_CATEGORIES_BY_CATEGORY,
  DocumentCategory,
  DocumentSubCategory,
  documentSubCategoryRequiresLinkedEvent as sharedDocumentSubCategoryRequiresLinkedEvent,
} from 'shared';

import { StringKey } from '../../../lang/index';
import {
  documentCategoryLabelKey,
  documentSubCategoryLabelKey,
  isDocumentSubCategory,
} from '../enums/document-category.const';

// Direct re-export from source so Babel (isolatedModules) keeps these as value bindings.
export { DocumentLinkedEventKind, getDocumentLinkedEventKind } from 'shared';

export const documentSubCategoryRequiresLinkedEvent = (
  subCategory: string | undefined,
): subCategory is DocumentSubCategory =>
  subCategory != null &&
  isDocumentSubCategory(subCategory) &&
  sharedDocumentSubCategoryRequiresLinkedEvent(subCategory);

const toSubCategoryOptions = (
  subCategories: DocumentSubCategory[],
): { labelKey: StringKey; value: DocumentSubCategory }[] =>
  subCategories.map((value) => ({
    labelKey: documentSubCategoryLabelKey[value],
    value,
  }));

export const documentCategoryOptions = DOCUMENT_CATEGORIES_SORTED.map((value) => ({
  labelKey: documentCategoryLabelKey[value],
  value,
}));

export const documentSubCategoryByCategory: Record<
  DocumentCategory,
  { labelKey: StringKey; value: DocumentSubCategory }[]
> = Object.fromEntries(
  DOCUMENT_CATEGORIES_SORTED.map((category) => [
    category,
    toSubCategoryOptions(DOCUMENT_SUB_CATEGORIES_BY_CATEGORY[category] ?? []),
  ]),
) as Record<DocumentCategory, { labelKey: StringKey; value: DocumentSubCategory }[]>;

export const getDocumentCategoryDisplayLabel = (
  category: DocumentCategory | undefined,
  messagesLocale: Record<string, string>,
): null | string => {
  if (!category) return null;
  return messagesLocale[documentCategoryLabelKey[category]] ?? null;
};

export const getDocumentSubCategoryDisplayLabel = (
  subCategory: null | string | undefined,
  messagesLocale: Record<string, string>,
): string => {
  if (!subCategory?.trim()) return '-';
  if (isDocumentSubCategory(subCategory)) {
    return messagesLocale[documentSubCategoryLabelKey[subCategory]] ?? subCategory;
  }
  return subCategory.trim();
};

export const getSignatureCategoryDisplayLabel = (
  category: string | undefined,
  messagesLocale: Record<string, string>,
): string => {
  if (!category) return '-';
  const documentCategory = Object.values(DocumentCategory).find((value) => value === category);
  if (documentCategory) {
    return getDocumentCategoryDisplayLabel(documentCategory, messagesLocale) ?? category;
  }
  return category;
};
